/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {

	viewResource : { myVideos: [], myContents: [], myDocuments: [], MyPodcasts: []	},
	Count        : {
		myVideoCount    : 0,
		myContentCount  : 0,
		myDocumentCount : 0,
		MyPodcastCount  : 0
	},
	networkList : [],
	uploadFile  : [],
	uploadInfo  : { image: [], video: [], document: [] },
	checkUpload : false

};

export const viewResourceSlice = createSlice({
	name     : 'myresource',
	initialState,
	reducers : {
		getResourcesData : (state, action) =>
		{
			state.viewResource = { ...state.viewResource, ...action.payload };
		},
		getResourcesCount : (state, action) =>
		{
			state.Count = { ...state.Count, ...action.payload };
		},
		getNetworkList : (state, action) =>
		{
			state.networkList = action.payload;
		},
		resetMyresourcesData()
		{
			return initialState;
		},
		setUploadFile	: (state, action) =>
		{
			state.uploadFile = action.payload;
			state.checkUpload = false;
		},
		setUploadInfo : (state, action) =>
		{
			state.uploadInfo = action.payload;
		},
		setCheckUpload : (state, action) =>
		{
			state.checkUpload = action.payload;
		}

	}

});
export const { getResourcesCount, getResourcesData, getNetworkList,
	resetMyresourcesData, setUploadFile, setUploadInfo,
	setCheckUpload } = viewResourceSlice.actions;
export default viewResourceSlice.reducer;
